import service from "@/utils/request";

// 直播列表
interface getLiveListData {
  page?: number;
  page_size?: number;
  start_date: string;
  end_date: string;
  class_id?: number;
  course_id?: number;
  teacher_id?: number;
  live_status?: number;
}
export const getLiveListApi = (data: getLiveListData) => {
  return service({
    url: "/api/v1/class/lesson/live/list",
    method: "post",
    data,
  });
};

// 获取上课URL
interface getLiveUrlData {
  lesson_id: number;
}
export const getLiveUrlApi = (data: getLiveUrlData) => {
  return service({
    url: "/api/v1/class/lesson/live/teacher_web_url",
    method: "post",
    data,
  });
};

// 获取巡课URL
interface getAdminLiveUrlData {
  lesson_id: number;
}
export const getAdminLiveUrlApi = (data: getAdminLiveUrlData) => {
  return service({
    url: "/api/v1/class/lesson/live/admin_web_url",
    method: "post",
    data,
  });
};

// 结束直播
interface endLiveData {
  lesson_id: number;
}
export const endLiveApi = (data: endLiveData) => {
  return service({
    url: "/api/v1/class/lesson/live/end",
    method: "post",
    data,
  });
};

// 直播回看
interface reviewLiveData {
  lesson_id: number;
}
export const reviewLiveApi = (params: reviewLiveData) => {
  return service({
    url: "/api/v1/class/lesson/live/video",
    method: "get",
    params,
  });
};

// 直播统计
export const liveTotalApi = () => {
  return service({
    url: "/api/v1/org/live/account/detail",
    method: "get",
  });
};
// 直播统计列表
interface liveTotalListData {
  page?: number;
  page_size?: number;
  lesson_id: number;
}
export const liveTotalListApi = (params: liveTotalListData) => {
  return service({
    url: "/api/v1/class/lesson/live/statistic/list",
    method: "get",
    params,
  });
};
// 直播-学员统计列表
interface liveStudentListData {
  lesson_id: number;
}
export const liveStudentListApi = (params: liveStudentListData) => {
  return service({
    url: "/api/v1/class/lesson/live/statistic/student/list",
    method: "get",
    params,
  });
};
// 学员上课web_url
interface studentWebUrlInter {
  lesson_id: number;
  student_id: number;
}
export const studentWebUrlApi = (data: studentWebUrlInter) => {
  return service({
    url: "/api/v1/class/lesson/live/student_web_url",
    method: "post",
    data,
  });
};
